import { Accordion, AccordionItem, Flex, ProgressCircle, SparklesIcon, Text } from 'components'
import noLeadsImage from '../assets/emptyStates/no_leads.svg'
import EmptyState from '../components/EmptyState'
import {
  WorkspaceAnalyticsContentSection,
  WorkspaceAnalyticsEventsSection,
  WorkspaceAnalyticsHeader,
  WorkspaceAnalyticsOverviewSection,
  WorkspaceAnalyticsProvider,
  WorkspaceAnalyticsSmartColumnsSection,
  WorkspaceAnalyticsUserTraitsSection,
  useWorkspaceAnalytics,
} from '../components/analytics'

export default function WorkspaceAnalyticsPage() {
  return (
    <WorkspaceAnalyticsProvider>
      <WorkspaceAnalyticsContent />
    </WorkspaceAnalyticsProvider>
  )
}

function WorkspaceAnalyticsContent() {
  const { status } = useWorkspaceAnalytics()

  const items: AccordionItem[] = [
    {
      title: 'Overview',
      content: WorkspaceAnalyticsOverviewSection(),
    },
    {
      title: 'Events',
      content: WorkspaceAnalyticsEventsSection(),
    },
    {
      title: (
        <Flex gap={4} align="center">
          <SparklesIcon color="primary.500" />
          <Text textStyle="bodyLarge">Smart Columns</Text>
        </Flex>
      ),
      content: WorkspaceAnalyticsSmartColumnsSection(),
    },
    {
      title: 'Content',
      content: WorkspaceAnalyticsContentSection(),
    },
    {
      title: 'User Traits',
      content: WorkspaceAnalyticsUserTraitsSection(),
    },
  ].filter(({ content }) => content)

  return (
    <Flex p={4} direction="column" gap={5} overflowY="auto">
      <WorkspaceAnalyticsHeader />
      {status === 'loading' ? (
        <Flex p={20} justifyContent="center" maxW={'100%'}>
          <ProgressCircle isIndeterminate />
        </Flex>
      ) : status === 'empty' ? (
        <EmptyState
          description="Once sessions are created, analytics will be available here to view and manage."
          pt={10}
          iconSrc={noLeadsImage}
          title="No Sessions"
        />
      ) : status === 'filtered-empty' ? (
        <EmptyState
          description="Adjust filters to see analytics."
          pt={10}
          iconSrc={noLeadsImage}
          title="No Sessions"
        />
      ) : (
        <Accordion
          key={items.length}
          multiple
          alignSelf="stretch"
          items={items}
          defaultValue={Array.from({ length: items.length }, (_, i) => i.toString())}
          buttonProps={{ backgroundColor: 'transparent' }}
        />
      )}
    </Flex>
  )
}
